module.exports = __webpack_public_path__ + "static/media/DSC00211.64ed236c.jpg";